import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const base =
  "group inline-flex items-center justify-center gap-2 rounded-full font-semibold transition-transform duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent focus-visible:ring-offset-2 will-change-transform active:scale-[0.98]";

const sizes = {
  md: "px-6 py-3 text-sm",
  lg: "px-8 py-4 text-base",
};

const variants = {
  primary: "bg-brand text-white hover:bg-brand-deep shadow-card hover:shadow-lift",
  accent: "bg-brand-accent text-white hover:bg-blue-600 shadow-card hover:shadow-lift",
  outline: "border border-brand/20 text-brand hover:bg-brand hover:text-white",
  ghost: "text-brand hover:bg-brand-light",
  white: "bg-white text-brand hover:bg-brand-light shadow-card",
  outlineLight: "border border-white/40 text-white hover:bg-white hover:text-brand",
};

export const CTAButton = ({
  children,
  to,
  href,
  onClick,
  variant = "primary",
  size = "md",
  arrow = true,
  className = "",
  type = "button",
  ...rest
}) => {
  const cls = `${base} ${sizes[size]} ${variants[variant]} ${className}`;
  const inner = (
    <>
      {children}
      {arrow && (
        <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
      )}
    </>
  );

  if (to) {
    return (
      <Link to={to} className={cls} onClick={onClick} {...rest}>
        {inner}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={cls} onClick={onClick} {...rest}>
        {inner}
      </a>
    );
  }
  return (
    <button type={type} className={cls} onClick={onClick} {...rest}>
      {inner}
    </button>
  );
};
